const campaignStatistics = {
  title: 'Statistiques de la campagne',
  loadError: 'Impossible de charger les statistiques de la campagne.',
  goalProgress: 'Progression vers l\'objectif',
  totalPledged: 'Total promis',
  goal: 'Objectif',
  ofGoal: 'de l\'objectif',
  noGoal: 'Aucun objectif défini pour cette campagne.',
  oneTimeGifts: 'Dons uniques',
  installmentsCollected: 'Versements reçus',
  feesCovered: 'Frais couverts par les donateurs',
  futureInstallments: 'Versements à venir',
  kpiGifts: 'Dons',
  kpiGiftsHint: 'Total des dons pour cette campagne',
  kpiDonors: 'Donateurs',
  kpiDonorsHint: 'Donateurs uniques',
  kpiAverageGift: 'Don moyen',
  kpiAverageGiftHint: 'Montant promis par don',
  kpiInstallmentShare: 'Payés en versements',
  kpiInstallmentShareHint: 'Part des dons sur un plan de paiement',
  kpiFeeDonors: 'Donateurs couvrant les frais',
  kpiFeeDonorsHint: 'Donateurs ayant ajouté les frais',
  donationsOverTime: 'Dons dans le temps',
  daily: 'Quotidien',
  weekly: 'Hebdomadaire',
  count: 'Dons',
  amount: 'Montant',
  oneTime: 'Dons uniques',
  installment: 'Dons en versements',
  runningTotal: 'Total cumulé',
  noDonations: 'Aucun don pour cette campagne pour le moment.',
  planMix: 'Dons uniques et versements',
  threeMonths: 'Plans sur 3 mois',
  sixMonths: 'Plans sur 6 mois',
  twelveMonths: 'Plans sur 12 mois',
  otherPlan: 'Autres plans',
  planLength: 'Plan',
  share: 'Part',
  installmentPlans: 'Plans de versements',
  active: 'Actifs',
  completed: 'Terminés',
  pastDue: 'En retard',
  expectedMonthly: 'Attendu par mois',
  activeHint: 'Plans en cours de perception',
  completedHint: 'Plans entièrement payés',
  pastDueHint: 'Plans avec un paiement échoué',
  expectedMonthlyHint: 'Pour les plans actifs',
  collected: 'Perçu',
  scheduled: 'À venir',
  noInstallments: 'Aucun plan de versements pour cette campagne.',
  canceledPlansExcluded: '%count% plan(s) annulé(s) exclu(s).',
  adminFeeCoverage: 'Couverture des frais administratifs',
  feeDonorsCovered: 'Donateurs couvrant les frais',
  feeDonorsCoveredHint: 'Donateurs ayant ajouté les frais',
  optInRate: 'Taux d\'adhésion',
  optInRateHint: 'Part des donateurs ayant ajouté les frais',
  charityPaid: 'Payé par l\'organisme',
  charityPaidHint: 'Frais non couverts par les donateurs',
  shareCovered: 'Part couverte',
  shareCoveredHint: 'Part des frais couverts par les donateurs',
  weeklyFees: 'Frais couverts par semaine',
  feeDonor: 'Donateur',
  date: 'Date',
  feeAmount: 'Frais',
  status: 'Statut',
  anonymous: 'Anonyme',
  feeNotEnabled: 'La couverture des frais n\'est pas activée pour cette campagne.',
  feeDataUnavailable: 'Les données de couverture des frais ne sont pas disponibles pour cette campagne.',
  noFeeDonors: 'Aucun donateur n\'a ajouté les frais pour cette campagne.',
  allDonations: 'Tous les dons',
  donor: 'Donateur',
  paymentType: 'Type de paiement',
  allPaymentTypes: 'Tous les types de paiement',
  pledged: 'Promis',
  remaining: 'Restant',
  noMatchingDonations: 'Aucun don ne correspond à ce type de paiement.',
  rowsPerPage: 'Lignes par page',
  of: 'sur',
  donationsCount: '%count% dons',
  warningTruncated: 'Certaines données ont été tronquées car la campagne contient plus de données que ce qui peut être chargé en une seule fois.',
  warningDonationsUnavailable: 'Les dons n\'ont pas pu être chargés. Les chiffres peuvent être incomplets.',
  warningInvoicesUnavailable: 'Les détails des factures n\'ont pas pu être chargés. Les montants perçus et les statuts des plans peuvent être incomplets.',
};

export default campaignStatistics;
